module.exports = __webpack_public_path__ + "static/img/case_banner_04.eed32de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_04.png
// module id = /i8Z
// module chunks = 34